// extracted by mini-css-extract-plugin
export default {"Form":"Form_Form__TxysT","inputDiv":"Form_inputDiv__bzEc+","info":"Form_info__eU7K+"};